import classNames from 'classnames';
import React from 'react';
import { NavLink } from 'react-router-dom';
import '../Navigation.scss';
import FontAwesomeIcon from '../../Icon';
import NewBadge from '../../NewBadge/NewBadge';

export const GenericLink = ({ link, collapseSideBar }) => (
  <li
    title={link.label}
    className="navigation__link"
    key={`nav-link-${link.label}`}
  >
    <NavLink
      to={link.path}
      isActive={(match, location) =>
        !!match ||
        (link.activePaths
          ? link.activePaths.some((path) => location.pathname.startsWith(path))
          : false)
      }
      className={classNames('navigation__anchor', {
        'navigation__anchor--collapsed': collapseSideBar,
      })}
      activeClassName="navigation__anchor--active"
    >
      <FontAwesomeIcon weight="light" glyph={link.icon} />
      <div
        className={classNames('navigation__anchor--label', {
          'navigation__anchor--label--collapse': collapseSideBar,
        })}
      >
        {link.label}
      </div>
      {link.label === 'Calendar' && !collapseSideBar && (
        <NewBadge beta className="navigation__calcom-badge" />
      )}
    </NavLink>
  </li>
);
